module.exports = __webpack_public_path__ + "static-portal/img/map-rtzf.ab44f9d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/map-rtzf.png
// module id = 64kQ
// module chunks = 4